export default "__VITE_ASSET__CnueVSiN__"